var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteHeart = function SvgWhiteHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.399,
    height: 19.784,
    viewBox: "0 0 22.399 19.784",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_96615_cc-2",
    transform: "translate(-0.536 -7.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16692",
    "data-name": "Group 16692",
    transform: "translate(1.036 7.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9702",
    "data-name": "Path 9702",
    d: "M9.423,25.654a3.135,3.135,0,0,0,4.54,0l6.738-7.1a6.54,6.54,0,0,0,0-8.871,5.687,5.687,0,0,0-8.37,0l-.6.625L11.14,9.68a5.687,5.687,0,0,0-8.37,0,6.538,6.538,0,0,0,0,8.869Zm0,0",
    transform: "translate(-1.036 -7.844)",
    fill: "rgba(255,255,255,0)",
    stroke: "#f5f5f5",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteHeart.c33047a2.svg";
export { ForwardRef as ReactComponent };